module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spouse-wrap"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "input-wrap input-wrap--spouse"
  }, [_c('button', {
    staticClass: "input input--spouse spouse__button",
    on: {
      "click": _vm.openPanel
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.setSpouseName))])]), _vm._v(" "), _c('Icon', {
    attrs: {
      "icon": "link"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4af86651!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spouse.vue
// module id = 319
// module chunks = 0